module.exports = __webpack_public_path__ + "static/media/1.9fde6b13.jpg";